import { combineReducers, type Reducer } from 'redux';

import { notifierReducer } from './notifier/reducer';
import { organizationsReducer } from './organizations/reducer';
import { safescarfReducers } from './safescarf/reducers';
import { statusReducer } from './status/reducer';
import type { RootState } from './types';
import { userReducer } from './user/reducer';
import { usersReducer } from './users/reducer';

const reducer = combineReducers({
  user: userReducer,
  notifier: notifierReducer,
  users: usersReducer,
  organizations: organizationsReducer,
  safescarf: safescarfReducers,
  status: statusReducer,
}) as unknown as Reducer<RootState>;

export default reducer;
